export default {"src":"/_next/static/media/WALLET.fbd9fc44.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};